import * as React from "react";
import * as Ons from "react-onsenui";
import { callNumber, openMailTo } from "./external_link";
import { STRINGS } from "./strings";
import { translate } from "./translate";
import { getNotchCss } from "./utils/DeviceUtils";

export interface UserLockedScreenProps {
  caregiverPhoneNumber: string;
}

export class UserLockedScreen extends React.Component<UserLockedScreenProps> {
  constructor(props: UserLockedScreenProps) {
    super(props);
  }

  render() {
    return (
      <Ons.Page>
        <div className="PhoneEntryScreen__root">
          <div className={`PhoneEntryScreen__logo ${getNotchCss("PhoneEntryScreen__logo", "")}`} />
          <div className="PhoneEntryScreen__header">
            {translate(STRINGS.USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY)}
            <br />
            <br />
            <u onClick={() => callNumber("+17185502775")}>
              {translate(STRINGS.CALL_SUPPORT_FOR_MORE_INFO)}
            </u>
            <br />
            <u
              onClick={() =>
                openMailTo(
                  "info@medflyt.com",
                  "My account was locked",
                  `Please help!, my phone is: ${this.props.caregiverPhoneNumber}`
                )
              }
            >
              {translate(STRINGS.EMAIL_SUPPORT_FOR_MORE_INFO)}
            </u>
          </div>
        </div>
      </Ons.Page>
    );
  }
}
